import defaultTheme from '@klaviyo-mkt/gatsby-components/shared/styles/themes/default';
import NotFound from '@klaviyo-mkt/gatsby-components/organisms/not-found';

import Layout from '../../templates/layout';
import GlobalHead from '../../templates/layout/head';

import type { HeadProps, PageProps } from 'gatsby';

const NotFoundPage = ( pageProps: PageProps ) => (
  <Layout
    {...pageProps}
    heroBackground="lightSand"
    templateName="Default"
    theme={defaultTheme}
    showBreadcrumbs={false}
  >
    <NotFound />
  </Layout>
);

export const Head = ({
  location,
}: HeadProps) => {
  const seo = {
    canonical: '',
    metaRobotsNofollow: 'nofollow',
    metaRobotsNoindex: 'noindex',
    title: 'Page not found | Klaviyo',
  } as const;

  return (
    <GlobalHead
      pathname={location.pathname}
      seo={seo}
    />
  );
};

export default NotFoundPage;
